import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  selectedLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('es');
  constructor() {
  }
}
